import { trackEvent } from 'dibs-tracking';

export const createClickTrackingEvent = (action: string) => {
    return (): void => {
        trackEvent({
            action,
            label: 'none',
            category: 'promo interaction',
        });
    };
};
